import { SiteHeader } from '../../shared/components/SiteHeader';
import { SiteFooter } from '../../shared/components/SiteFooter';
import { PageHero } from '../../shared/components/PageHero';
import { MapSection } from '../../shared/components/MapSection';
import { useLang } from '../../../i18n/LanguageContext';
import { aboutDict } from '../../../i18n/dictionaries/about';
import styles from './AboutPage.module.css';
import heroImage from '../../../assets/about/hero.png';
import profileImage from '../../../assets/about/profile.png';

export const AboutPage = (): JSX.Element => {
  const { lang } = useLang();
  const t = aboutDict[lang];

  return (
    <div className={styles.page}>
      <SiteHeader variant="solid" />

      <PageHero image={heroImage} eyebrow="COMPANY" title={t.heroTitle} />

      <section className={styles.profile}>
        <div className={styles.sectionHead}>
          <p className={styles.eyebrow}>PROFILE</p>
          <h2 className={styles.sectionTitle}>{t.profileTitle}</h2>
        </div>
        <div className={styles.profileBody}>
          <img
            className={styles.profileImage}
            src={profileImage}
            alt={`${t.signRole} ${t.signName}`}
          />
          <div>
            <div className={styles.profileMessage}>
              {t.profileMessage.map((paragraph) => (
                <p key={paragraph.slice(0, 12)}>{paragraph}</p>
              ))}
            </div>
            <div className={styles.profileSign}>
              <p className={styles.signRole}>{t.signRole}</p>
              <p className={styles.signName}>{t.signName}</p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.career}>
        <div className={styles.careerBox}>
          <div className={styles.sectionHead}>
            <p className={styles.eyebrow}>CAREER</p>
            <h2 className={styles.sectionTitle}>{t.careerTitle}</h2>
          </div>
          <div className={styles.careerList}>
            {t.careerHistory.map((entry) => (
              <p key={entry}>{entry}</p>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.company}>
        <div className={`${styles.sectionHead} ${styles.companyHead}`}>
          <p className={styles.eyebrow}>ABOUT COMPANY</p>
          <h2 className={styles.sectionTitle}>{t.companyTitle}</h2>
        </div>
        <table className={styles.infoTable}>
          <tbody>
            {t.companyInfo.map((row) => (
              <tr key={row.label}>
                <th scope="row">{row.label}</th>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <MapSection />

      <SiteFooter bordered />
    </div>
  );
};
